module.exports = __webpack_public_path__ + "img/pencil-landscape_cn.4c0e950.jpg";